import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import {
  Container,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Button,
  Grid,
  Paper,
  styled,
  CircularProgress, // Import CircularProgress
} from "@mui/material";

// const server_uri = "http://localhost:5000";
// https://server-pthsalon.fly.dev
// const server_uri = "https://salonserver-0ojm.onrender.com";
const server_uri = "https://pth-salon-server.fly.dev";
// Styled components
const FormContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

const FormPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
}));

const SubmitButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const servicesList = [
  "Hair Cut Men/Women/Children",
  "Hair Styling/Colouring",
  "Hair Curling",
  "Straightning",
  "Facial",
  "Body Waxing",
  "Eyebrow/Fullface",
  "Highlights",
  "Others",
];

const locations = [
  // "12990 National Rd.",
  // "8515 Refugee Rd.",
  "859 Windmiller Dr.",
];

const BookAppointment = () => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    contactNumber: "",
    location: "",
    services: [],
  });

  const [loading, setLoading] = useState(false); // Loading state

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleServiceChange = (service) => {
    const newServices = formData.services.includes(service)
      ? formData.services.filter((s) => s !== service)
      : [...formData.services, service];
    setFormData({ ...formData, services: newServices });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading spinner
    try {
      console.log(formData);
      await axios.post(`${server_uri}/api/appointments`, formData);
      alert("Appointment booked successfully!");
      navigate("/");
    } catch (err) {
      console.error(err);
      alert("Failed to book appointment. Please try again.");
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };

  return (
    <FormContainer maxWidth="md">
      <FormPaper elevation={3}>
        <Typography variant="h4" gutterBottom>
          Book Appointment
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Your Name"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Contact Number"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <FormControl fullWidth>
                <InputLabel>Salon Location</InputLabel>
                <Select
                  fullWidth
                  label="Salon Location"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  required
                  variant="outlined"
                  sx={{ minWidth: 150 }}
                >
                  {locations.map((loc, index) => (
                    <MenuItem key={index} value={loc}>
                      {loc}
                    </MenuItem>
                  ))}
                </Select>
                {/* <span>8515 Refugee Rd. : Appointment only bookings</span> */}
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Select Services
              </Typography>
              <Grid container spacing={1}>
                {servicesList.map((service, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.services.includes(service)}
                          onChange={() => handleServiceChange(service)}
                          color="primary"
                        />
                      }
                      label={service}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <SubmitButton
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                disabled={formData.services.length === 0 || loading} // Disable button while loading
                fullWidth
              >
                {loading ? (
                  <CircularProgress size={24} color="secondary" /> // Show spinner while loading
                ) : (
                  "Book Appointment"
                )}
              </SubmitButton>
            </Grid>
          </Grid>
        </form>
      </FormPaper>
    </FormContainer>
  );
};

export default BookAppointment;
